import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Star, Check, X, Trash2, Pin } from "lucide-react";
import { useApi, errMsg } from "@/lib/api";

const BADGE = { pending: "bg-amber-100 text-amber-800", approved: "bg-teal-100 text-teal-800", rejected: "bg-rose-100 text-rose-700" };

export const AdminReviews = () => {
  const api = useApi();
  const [items, setItems] = useState([]);
  const load = useCallback(() => api("get", "/admin/reviews").then(setItems).catch(() => {}), [api]);
  useEffect(() => { load(); }, [load]);

  const act = async (r, method, body) => {
    try { await api(method, `/admin/reviews/${r.id}`, body); toast.success("Review updated"); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="grid gap-4 md:grid-cols-2" data-testid="admin-reviews-list">
      {items.map((r) => (
        <div key={r.id} className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="admin-review-card">
          <div className="flex items-start justify-between gap-3">
            <div>
              <p className="font-display font-semibold text-slate-800">{r.name} <span className="text-xs font-normal text-slate-400">· {r.source}</span></p>
              <div className="flex">{[...Array(r.rating)].map((_, k) => <Star key={k} className="h-3.5 w-3.5 fill-[#f5b82e] text-[#f5b82e]" />)}</div>
            </div>
            <span className={`rounded-full px-2.5 py-1 text-xs font-bold capitalize ${BADGE[r.status]}`}>{r.status}</span>
          </div>
          <p className="mt-3 text-sm text-slate-600">{r.text}</p>
          <div className="mt-4 flex flex-wrap gap-2">
            {r.status !== "approved" && <button onClick={() => act(r, "patch", { status: "approved" })} data-testid="admin-review-approve-btn" className="inline-flex items-center gap-1 rounded-full bg-teal-600 px-3 py-1.5 text-xs font-bold text-white"><Check className="h-3.5 w-3.5" />Approve</button>}
            {r.status !== "rejected" && <button onClick={() => act(r, "patch", { status: "rejected" })} data-testid="admin-review-reject-btn" className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-3 py-1.5 text-xs font-bold text-slate-700"><X className="h-3.5 w-3.5" />Hide</button>}
            <button onClick={() => act(r, "patch", { featured: !r.featured })} data-testid="admin-review-feature-btn" className={`inline-flex items-center gap-1 rounded-full px-3 py-1.5 text-xs font-bold ${r.featured ? "bg-[#f5b82e] text-slate-900" : "bg-slate-100 text-slate-700"}`}><Pin className="h-3.5 w-3.5" />{r.featured ? "Featured" : "Feature"}</button>
            <button onClick={() => window.confirm("Delete review?") && act(r, "delete")} data-testid="admin-review-delete-btn" className="ml-auto text-rose-600" aria-label="Delete"><Trash2 className="h-4 w-4" /></button>
          </div>
        </div>
      ))}
    </div>
  );
};
